import {Injectable, inject} from '@angular/core'
import type {AnalyticsProvider} from './analytics-provider.interface'
import {environment} from '@cart/src/environments/environment'
import {InfoService} from '../info.service'
import {LogType, Logger} from '../utils/logger'
import {PosthogService} from './posthog.service'

@Injectable({providedIn: 'root'})
export class PostHogAnalyticsProvider implements AnalyticsProvider {
  readonly #posthogService = inject(PosthogService)
  readonly #infoService = inject(InfoService)

  async init(): Promise<void> {
    // PosthogService auto-initializes in its constructor
  }

  isEnabled(): boolean {
    return environment.analytics && this.#infoService.isWeb() && !!environment.posthogKey
  }

  trackEvent(name: string, properties?: Record<string, unknown>): void {
    if (!this.isEnabled()) {
      return
    }

    Logger.log(LogType.debug, '[PostHog] trackEvent', name, properties)
    this.#posthogService.trackEvent(name, properties)
  }

  identifyUser(userId: string, properties?: Record<string, unknown>): void {
    if (!this.isEnabled()) {
      return
    }

    Logger.log(LogType.debug, '[PostHog] identifyUser', userId, properties)
    this.#posthogService.identifyUser(userId, properties)
  }

  resetUser(): void {
    if (!this.isEnabled()) {
      return
    }

    Logger.log(LogType.debug, '[PostHog] resetUser')
    this.#posthogService.resetUser()
  }

  setScreen(name: string): void {
    if (!this.isEnabled()) {
      return
    }

    Logger.log(LogType.debug, '[PostHog] setScreen', name)
    this.#posthogService.trackEvent('$screen_view', {screen_name: name})
  }
}
